import React from 'react';
import { Document, Page, View, StyleSheet } from '@react-pdf/renderer';
import { PDF_THEMES, DEFAULT_THEME } from '../themes';
import PdfHeader from '../components/PdfHeader';
import PdfFooter from '../components/PdfFooter';
import PdfSummaryCards from '../components/PdfSummaryCards';
import { PdfTableHead, PdfTableRow, PdfTableFoot } from '../components/PdfTable';
import { fmtINR, fmtDate, cap } from '../pdfUtils';

const s = StyleSheet.create({
  page:    { fontFamily: 'NotoSans', paddingBottom: 60 },
  content: { marginHorizontal: 40, marginTop: 12 },
});

const COLS = [
  { label: 'Date',         flex: 0.9 },
  { label: 'Receipt No',   flex: 1 },
  { label: 'Donor Name',   flex: 1.5 },
  { label: 'Category',     flex: 1.8 },
  { label: 'Payment Mode', flex: 1 },
  { label: 'Amount (₹)',   flex: 1.1, align: 'right' },
];

export default function AnonymousDonationsDocument({ data, theme: themeKey, orientation, sections }) {
  const t = PDF_THEMES[themeKey] || PDF_THEMES[DEFAULT_THEME];
  const rows = Array.isArray(data.rows) ? data.rows
    : Array.isArray(data.filtered) ? data.filtered : [];
  const total = data.totalAmount ?? rows.reduce((s, r) => s + Number(r.amountInr || 0), 0);

  return (
    <Document>
      <Page size="A4" orientation={orientation || 'landscape'} style={[s.page, { backgroundColor: t.white }]}>
        {sections.header && <PdfHeader derasar={data.derasar} reportTitle="Anonymous Donations" theme={t} />}
        <View style={s.content}>
          {sections.summaryCards && (
            <PdfSummaryCards theme={t} items={[
              { label: 'Total Entries', value: String(rows.length), color: t.primary },
              { label: 'Total Amount',  value: fmtINR(total),       color: t.body   },
            ]} />
          )}
          <PdfTableHead cols={COLS} theme={t} />
          {rows.map((row, i) => (
            <PdfTableRow key={i} cols={COLS} index={i} theme={t}
              values={[
                fmtDate(row.receiptDate),
                row.receiptNo || '—',
                row.donorName || 'Anonymous',
                row.donationCategory?.name || '—',
                cap(row.paymentMode),
                fmtINR(row.amountInr),
              ]}
            />
          ))}
          <PdfTableFoot cols={COLS} values={['', `${rows.length} entries`, '', '', '', fmtINR(total)]} theme={t} />
        </View>
        {sections.footer && <PdfFooter theme={t} />}
      </Page>
    </Document>
  );
}


